module.exports = __webpack_public_path__ + "img/ico035.a2296725.svg";